import "./App.css";
import Layout from "./layouts";
import HomePage from "./pages/home";

export default function App() {
  return (
    <Layout>
      <HomePage />
    </Layout>
  );
}
